export default function mask() {
    if (document.querySelector("#phone")) {
        $("#phone").mask("(00) 00000-0000");
    }

    if (document.querySelector(".page-echeckout")) {
        $("#number-card").mask("0000 0000 0000 0000");
        $("#validity-card").mask("00/0000");
        $("#code-card").mask("000");
    }
}
